import React, { Component } from 'react';
import { withRouter } from '../../../util/withRouter';
import { connect } from 'react-redux';
import Header from '../../../components/Header/Header';

// Import Style
import '../style.scss';

class GenericMessagePage extends Component {
  getMessage() {
    const { user } = this.props;
    const email = !user.hasOwnAccount && !!user.managedBy ? user.managedBy : user.email;
    const mailToLink = `mailto:${email}`;

    switch (this.props.route.path) {
      case 'no-dashboards': {
        return (
          <React.Fragment>
            <h1>No dashboards available</h1>
            <p>
              It looks like you don't have the necessary permissions to create new dashboards right now.
            </p>
            <p>
              To request access, please click the button below.
            </p>
            <a href={mailToLink} className='btn btn-primary'>Request Permissions</a>
          </React.Fragment>
        );
      }      
      case 'no-create-dashboard-permissions': {
        const { router } = this.props;
        const noDashboard = router && router.location && router.location.query &&
          router.location.query['no-dashboard'] == 'true';
        return (
          <React.Fragment>
            <h1>No dashboards available</h1>
            {noDashboard ?
              <React.Fragment>
                <p>
                  You don't have access to the boards associated with this dashboard.
                </p>
                <p>
                  To request access, please click the button below.
                </p>
                <a href={mailToLink} className='btn btn-primary'>Request permissions</a>
              </React.Fragment>
              :
              <React.Fragment>
                <p>
                  It looks like you don't have the necessary permissions to create new dashboards right now.
                </p>
                <p>
                  To request access, please click the button below.
                </p>
                <a href={mailToLink} className='btn btn-primary'>Request permissions</a>
              </React.Fragment>

            }
          </React.Fragment>
        );
      }
      case 'no-manage-billing': {
        return (
          <React.Fragment>
            <h1>No billing access</h1>
            <p>
              It looks like you don't have billing permissions.
            </p>
            <p>
               Please reach out to your account admin <a href={`mailto:${this.props.user.managedBy}`}>{this.props.user.managedBy}</a> to upgrade your plan.
            </p>
          </React.Fragment>
        );
      }
      case 'expired': {
        const { user } = this.props;
        if (user.isCustomPlan) {
          return (
            <React.Fragment>
              <h1>Enjoyed your trial? Let's make it official.</h1>
              <p>
                Your free trial has come to an end, and access to the analytics suite is no longer available.
              </p>
              <p>
                To continue using the platform, request a pricing quote and our team will get in touch.
              </p>
              <a href='mailto:hello@getnave.com' className='btn btn-primary'>Request pricing quote</a>
            </React.Fragment>
          );
        }
        return (
          <React.Fragment>
            <h1>Your free trial has expired</h1>
            <p>
              Your free trial has come to an end, and access to the analytics suite is no longer available.
            </p>
            <p>
              To continue using the platform, please upgrade your account using the button below. If you have any questions, feel free to contact us directly at <a href="mailto:hello@getnave.com" >hello@getnave.com</a>.
            </p>
            <a href='/subscribe' className='btn btn-primary'>Upgrade now</a>
          </React.Fragment>
        );
      }
      case 'unlicensed': 
      case 'cancelled': {
        const { plugin } = this.props;
        return (
          <React.Fragment>
            <h1>Access unavailable</h1>
            <p>
              It looks like your access to the analytics suite is currently inactive. This may be due to a canceled subscription or because no active license is associated with your account.
            </p>
            <p>
              To regain access or resolve this issue, please contact your account owner at <strong>{email}</strong> for further assistance.
            </p>
            
          </React.Fragment>
        );
      }
      case 'no-streams': {
        const { user, isLoading } = this.props;
        const canCreateStreams = user && user.permissions && user.permissions.createStreams;
        const style = isLoading ? { visibility: 'hidden' } : {};
        return (
          <div style={style}>
            {(isLoading || canCreateStreams) ? (
              <>
                <h1>Create your first value stream</h1>
                <p>
                  Select the team dashboards you'd like to include to build a value stream and visualize your end to end delivery flow.
                </p>
                <a href='/configure' className='btn btn-primary'>Create value stream</a>
              </>
            ) : (
              <h1>No value streams available</h1>
            )}
          </div>
        );
      }
      case 'no-value-stream-permissions':{
        return (
          <React.Fragment>
            <h1>No value streams available</h1>
              <React.Fragment>
                <p>
                  It looks like you don't have the necessary permissions to view this value stream right now.
                </p>
               
                <a href='/report' className='btn btn-primary'>View own Value Streams</a>
              </React.Fragment>              
          </React.Fragment>
        );
      }
      case 'no-portfolios': {
        const { user, isLoading } = this.props;
        const canCreatePortfolios = user && user.permissions && user.permissions.createPortfolios;
        const style = isLoading ? { visibility: 'hidden' } : {};
        return (
          <div style={style}>
            {(isLoading || canCreatePortfolios) ? (
              <>
                <h1>Create your first portfolio</h1>
                <p>
                  Select the value streams you want to include to build a portfolio and track performance across your organization.
                </p>
                <a href='/portfolio' className='btn btn-primary'>Create portfolio</a>
              </>
            ) : (
              <h1>No portfolios available</h1>
            )}
          </div>
        );
      }
      case 'hosts-not-allowed': {
        return (
          <React.Fragment>
            <h1>No approved Azure DevOps organization found</h1>
            <p>
              Your Microsoft account cannot access an Azure DevOps organization approved for use with Nave. Contact Nave to use one of your organizations.
            </p>
            <p>
              <a href='mailto:hello@getnave.com' className='btn btn-primary'>Contact Nave</a>
            </p>
            <p>
              <a href='/login'>Back to login</a>
            </p>
          </React.Fragment>
        );
      }
      case 'no-enough-streams': {
        return (
          <React.Fragment>
            <h1>You’ll need at least two value streams to build a portfolio</h1>
            <p>
              Please create a new value stream before proceeding.
            </p>            
            <a href='/configure?fromPortfolio=true' className='btn btn-primary'>Create value stream</a>
          </React.Fragment>
        );
      }
    }
  }
  getImage() {
    switch (this.props.route.path) {     
      case 'no-streams': {
        return ' streams';
      }
      case 'no-portfolios': {
        return ' portfolios';
      }
      case 'no-enough-streams': {
        return ' no-enough-streams';
      }
    }
  }

  render() {
    const classImg = 'no-dashboard-dog' + this.getImage();
    return (
      <div>
        <Header showHome={!['unlicensed', 'hosts-not-allowed'].includes(this.props.route.path)} />
        <div className='no-dashboard'>
          <div className='no-dashboard-content'>
            {this.getMessage()}
          </div>
          <div className={classImg}>

          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    isLoading: state.auth.isLoading
  };
}

export default withRouter(connect(mapStateToProps)(GenericMessagePage));
